import PropertyTypeBadge from './PropertyTypeBadge';
export default PropertyTypeBadge;
